module.exports = __webpack_public_path__ + "static/media/IMG_8945.3cd5a44d.JPG";